export default __webpack_public_path__ + "static/BanImg2-72c40cbadf003f4257c81e998548e316.webp";